import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  TextField,
  Stack,
  useTheme,
} from "@mui/material";
import { IRaffle } from "../../../store/interfaces/IRaffle";

interface ChatBoxProps {
  raffle: IRaffle;
}

export const ChatBox = ({ raffle }: ChatBoxProps) => {
  const theme = useTheme();
  const showPremiumAlert = true;

  return (
    <Card
      sx={{
        mx: "auto",
        p: 3,
        borderRadius: 3,
        boxShadow: 4,
        maxWidth: 900,
        textAlign: "center",
      }}
    >
      <CardContent
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "400px",
          overflow: "hidden",
        }}
      >
        {showPremiumAlert && (
          <>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backdropFilter: "blur(2px)",
                zIndex: 1,
              }}
            />
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 12,
                backgroundColor: "black",
                border: `2px solid white`,
                borderRadius: 2,
                padding: 4,
                boxShadow: 6,
                textAlign: "center",
                maxWidth: 420,
              }}
            >
                <Typography variant="h6" color="warning.main" gutterBottom>
                  🤖 Chatbot con IA (en desarrollo)
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Este módulo permitirá agregar un <strong>chatbot inteligente</strong> para responder preguntas frecuentes de tus compradores.
                </Typography>
                <Typography variant="body2" color="text.secondary" mt={2}>
                  También podrás personalizar el saludo, añadir respuestas automáticas y definir su comportamiento con tu marca.
                </Typography>
                <Typography variant="body2" color="text.secondary" mt={2} fontWeight="bold">
                  Lanzamiento estimado: <span style={{ color: theme.palette.warning.main }}>15 de septiembre</span>
                </Typography>
                <Typography variant="body2" color="text.secondary" mt={1}>
                  Disponible solo para rifas con plan Premium.
                </Typography>
            </Box>
          </>
        )}

        <Typography variant="h5" color="primary" gutterBottom>
          🤖 Configuración del Chatbot con IA
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: "text.secondary" }}>
          Configura mensajes iniciales y preguntas frecuentes para ayudar a tus compradores automáticamente.
        </Typography>

        <Stack spacing={2} sx={{ mt: 3, width: "100%", maxWidth: 600 }}>
          <TextField
            label="Saludo inicial del chatbot"
            placeholder="¡Hola! ¿En qué puedo ayudarte con esta rifa?"
            fullWidth
            disabled={showPremiumAlert}
          />
          <TextField
            label="Pregunta frecuente #1"
            placeholder="Ej: ¿Cuándo es el sorteo?"
            fullWidth
            disabled={showPremiumAlert}
          />
          <TextField
            label="Respuesta #1"
            placeholder="La rifa se sortea el 25 de cada mes en vivo."
            fullWidth
            disabled={showPremiumAlert}
          />
          <TextField
            label="Pregunta frecuente #2"
            placeholder="Ej: ¿Cómo sé si gané?"
            fullWidth
            disabled={showPremiumAlert}
          />
          <TextField
            label="Respuesta #2"
            placeholder="Los ganadores se publican y reciben un correo automático."
            fullWidth
            disabled={showPremiumAlert}
          />
        </Stack>
      </CardContent>
    </Card>
  );
};
